import React, { useState, useEffect } from "react";
import { manejarError } from "../manejo_errores";
import { useNavigate, Link } from "react-router-dom";
import { HeaderAsociacion } from "../componentes/headerAsociacion";
import { Button, Checkbox, Form, Input, Flex, Alert } from "antd";
import axios from "axios";

import { CustomFooter } from "../componentes/footer";
import { BotonPrincipal } from "../componentes/btnPrincipal";
import { FranjaFija } from "../componentes/franjaFija";
export const Login = ({ setAlerta }) => {
  const manejarAlertas = (tipo, mensaje) => {
    // Usar setAlerta para mostrar la alerta
    setAlerta({ message: mensaje, type: tipo });
  };
  // Función para manejar el envío del formulario
  const navigate = useNavigate();
  const onFinish = async (values) => {
    try {
      // Aquí puedes realizar la lógica de autenticación, como una llamada a la API
      const logearse = await axios.post(
        process.env.REACT_APP_DOMINIO + `/login`,
        {
          dni: values.dni,
          password: values.password,
        },
        {
          withCredentials: true,
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (logearse.status === 200) {
        manejarAlertas("success", "Bienvenido, seleccione una asociacion.");
        const now = new Date();
        const expiration = Math.floor(
          (now.getTime() + 1 * 60 * 60 * 1000) / 1000
        );
        localStorage.setItem(
          "administradoresSessionToken",
          logearse.data.token,
          expiration
        );
        navigate("/admin");
      }
    } catch (error) {
      manejarAlertas("error", manejarError(error));
    }
  };

  return (
    <>
      <HeaderAsociacion grande>
        <Link to="/" className="header-asoc-enlace">
          Inicio
        </Link>
      </HeaderAsociacion>

      <FranjaFija izq="#D9D9D9">
      <section className="login-adm" id="seccionLogin">
        <div className="login-adm-interior">
          <div className="login-adm-cabecera">
            <div className="login-adm-fila">
              <span className="login-adm-barra" />
              <span className="login-adm-etiqueta">Administración</span>
            </div>
            <h1 className="login-adm-titulo">Ingresá con tu cuenta de administrador</h1>
          </div>

          <div className="login-adm-tarjeta">
            <Form
              name="login"
              initialValues={{
                remember: true,
              }}
              onFinish={onFinish}
            >
              <Form.Item
                name="dni"
                rules={[
                  {
                    required: true,
                    message: "Por favor, ingresa tu DNI!",
                  },
                ]}
              >
                <Input
                  className="input-dni"
                  placeholder="DNI"
                />
              </Form.Item>

              <Form.Item
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Por favor, ingresa tu contraseña",
                  },
                ]}
              >
                <Input.Password
                  className="input-password"
                  placeholder="Contraseña"
                  visibilityToggle={{ visible: false }}
                />
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit" className="boton-principal">
                  Ingresar
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </section>
      </FranjaFija>
      <CustomFooter />
    </>
  );
};
